<template>

  <div class="col-xs-12">

      <div class="panel">
          <div class="panel-heading"><h2>Forum<i class="clippie fa fa-info-circle" v-tooltip="'Forums for sharing and helping each other'"></i></h2></div>
          <div class="panel-body">
<!--             <form class="search">
                    <div class="form-group">
                        <div class="input-group">


                      <typeahead v-model="newTag" ref="typeahead" target="#query" match-start :data="tags" item-key="name">

                            <template slot="item" scope="props">
                                <li v-for="(item, index) in props.items" :class="{active:props.activeIndex===index}">
                                  <a role="button" @click="pushTag(item); newTag=null">
                                    {{item.name | ucwords}}
                                  </a>
                                </li>
                          </template>

                        </typeahead>

                        <input type="text" id="query"  v-model="searchTerm" placeholder="Search" class="form-control">

                          <span class="input-group-btn">
                              <button @click.prevent="search()" class="btn btn-primary">Search</button>
                          </span>
                      </div>

                    <ul class="post-tags clearfix">
                        <li v-for="(tag, $index) in tagQuery">{{tag.name | ucwords}}<span class="remove" @click="tagQuery.splice($index,1)">x</span></li>
                    </ul>

                </div>
            </form> -->
            <div class="forums" v-if="!results.topics || noResults">
                <ul class="threads clearfix" v-if="subforums">
                <li class="clearfix forum-header">
                    <div class="col-xs-2"></div>
                    <div class="col-xs-4 title-header">Title</div>
                    <div class="col-xs-2">Statistics</div>
                    <div class="col-xs-3">Last Post</div>
                </li>
                <li v-for="subforum in subforums" class="row thread clearfix">
                    <div class="col-xs-2 col-md-2 forum-image">
                        <router-link :to="{ name: 'discussion', params: { forumId: subforum.id } }">
                            <img v-if="subforum.image" v-bind:src="subforum.image">
                            <img v-else src="../../assets/img/ttto-thumbnail.jpg">
                        </router-link>
                    </div>
                    <div class="col-xs-4 col-md-4 forum-link">
                        <router-link :to="{ name: 'discussion', params: { forumId: subforum.id } }">
                            <h4>{{subforum.title}}</h4>
                        </router-link>
                    </div>
                    <div class="col-xs-2 col-md-2 stats-wrapper">
                        {{subforum.topic_count}} Threads<br>
                        {{subforum.post_count}} Posts
                    </div>
                    <div class="col-xs-4 col-md-4 last-post-wrapper" v-if="subforum.latestPost">

                        <span class="last-post">
                            <router-link  :to="{ name: 'thread', params: { forumId: subforum.id, topicId: subforum.latestPost.thread, postId: subforum.latestPost.id } }">
                                {{subforum.latestPost.title | truncate(35)}}<br>
                            </router-link>

                        </span>
                            by:
                         <span class="post-author-link ">
                             <router-link :to="{ name: 'posts-by-user', query: { userId: subforum.latestPost.userId } }">
                                  <img :src="subforum.latestPost.roles | roleIcon(subforum.latestPost.terms)" class="role-icon">

                                 {{subforum.latestPost.name}}<br>



                            </router-link>
                        </span>
                            {{subforum.latestPost.createdAt | timeago}}

                    </div>

                </li>
            </ul>
        </div>
        <div v-else class="search-results">

            <ul v-if="(results.topics || results.posts) && (results.topics.length > 0 || results.posts.length > 0)" class="list-group results">
                <li
                v-for="topic in results.topics"
                class="list-group-item">
                    <router-link :to="{ name: 'thread', params: { forumId: topic.subforumId, topicId: topic.id }}">
                        <span class="topiced-at">{{topic.createdAt | shortDate}}</span>
                        <p v-html="topic.title"></p>
                    </router-link>
                </li>
                <li
                v-for="post in results.posts"
                class="list-group-item">
                {{post}}
                    <router-link :to="{ name: 'thread', params: { forumId: post.forumId, topicId: post.topicId }}">
                        <span class="posted-at">{{post.createdAt | shortDate}}</span>
                        <p v-html="post.ts_headline"></p>
                    </router-link>
                </li>
            </ul>
            <div v-else class="no-results">No results found</div>
        </div>
    </div>
</div>
</div>


</template>


<script>
    // TODO: remove this, it's from the old forum.

    import discussions from '../../services/discussions';
    import courses from '../../services/courses';

    import _ from 'underscore';
    import { Typeahead } from 'uiv'

    export default {
        props:['course'],
        data() {
            return {
                subforums: null,
                searchTerm: null,
                results: {topics: null, posts:null},
                noResults: false,
                tags:null,
                tagQuery: []

            }
        },
        components: {
            Typeahead
        },
        mounted() {
            var self = this;
            this.getSubForums();
            this.getTags();
        },
        methods: {
            pushTag(tag) {
                this.tagQuery.push(tag)
            },
            getTags() {
                var self = this;
                discussions.getTags(this).then(function(response) {
                    self.tags = response.data.tags;
                });
            },
            search() {
                var context = this;
                let tags = this.tagQuery.map(function(t) { return t.id});
                discussions.search(this, this.searchTerm, tags).then(function(response) {
                    console.log(response);
                    context.results.posts = response.data.posts || [];
                    context.results.topics = response.data.topics;
                });
            },
            getSubForums() {
                var self = this;

                discussions.getSubForums(this).then(function(response) {
                    var subforums = response.data;
                    let index = subforums.findIndex(function(s) { return s.courses[0] == '1111111'});
                    subforums.push(subforums.splice(index, 1)[0]);
                    index = subforums.findIndex(function(s) { return s.courses[0] == '0000000'});
                    subforums.unshift(subforums.splice(index, 1)[0]);
                    self.subforums = subforums;

                });

            }
        }
    }
</script>

<style lang="scss" scoped>

    h4 {
        margin-top:0;
        margin-bottom: 0;
        font-weight:100;
    }

    h4:hover {
            text-decoration: underline;
        }



    .threads {
        padding: 0 1.4rem;
        margin-top:-2rem;

        img {
            //flex-shrink: 0;
            //max-width: 100%;

            //max-width: 140px;
            //max-height: 100%;
              /*width: auto;
              height: auto;
                        */
        }

        .forum-image {
            padding: 0!important;
            //text-align: center;
            //display: flex;
            //justify-content: center;
            //align-items: center;
            overflow: hidden;

            img {
                 max-height: 75px;
                object-fit: cover;
                width: 80%;
                height: 100%;
            }

        }

        a {
        height: 75px;
        overflow: hidden;
        //display: block;
        }
        a, a:active, a:visited {
            color:inherit;

        }
        a:hover {
            color: #33ccff;
            text-decoration: none;
        }
        li.header {
            margin: 0 -1.4rem;
            background:#1c1c1c;
            padding-top:2rem;
            box-shadow: 0px 5px 5px rgba(0,0,0,.3);
        }
        li.thread {
            background:#2c2c2c;
            margin-bottom:1rem;
            padding-bottom:10px;
            height:75px;
            .stats-wrapper {
                height:75px;
                border-left:1px solid #1c1c1c;
                border-right:1px solid #1c1c1c;
                background-color: #333;
            }
            & > div {
                padding-top:1rem;
            }
            .stats {
                background: #363636;
                padding-bottom:3.3rem;
            }
        }
    }

   .forum-header {
    background: #666;
    display: block;
    margin-top: 17px;
    height: 40px;
    padding-top: 11px;
    margin-left: -5px;
    margin-right: -5px;
    color: white;
    }

    .post-author-link {
        a {
            color:#33ccff!important;
        }
        a:hover {
            color:white!important;
            text-decoration: underline;
        }
    }
    .last-post{
        a {
            color:#33ccff!important;
        }
         a:hover {
            color:white!important;
            text-decoration: underline;
        }
}
.last-post-wrapper {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.forum-link {
    padding-left:0px;
}

.title-header {
    padding-left:0px;
}
.results {
    li {
        cursor: pointer;
        a {
            color:inherit;
            &:hover {
                color: #33ccff;
            }
        }
    }
}
.posted-at {
    display:block;
    font-style:italic;
}
.no-results {
    padding: 1rem;
    padding-bottom: 2rem;
    text-align: center;
}
</style>

<style lang="scss">
form.search .dropdown {
    top:5rem;
}
</style>



// WEBPACK FOOTER //
// Forum.vue?61c4dafa